import { Component } from '../../scripts/component';
import getLocalWishlist from '../../scripts/wishlist/getLocalWishlist';
import { getProductGidFromHandle, updateRemoteWishlist } from '../../scripts/wishlist/requests';
import { CONSTANTS } from '../../scripts/wishlist/vars';

/**
 * Wishlist button Component
 * Handles adding/removing products from wishlist
 */

class WishlistButton extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.updateWishlistState(false);
  }

  get productHandle() {
    return this.dataset.productHandle;
  }

  toggleWishlist() {
    this.updateWishlistState();
  }

  async getProduct() {
    if (!this.productHandle) return null;
    const product = await getProductGidFromHandle(this.productHandle);
    return product;
  }

  async updateWishlistState(shouldChangeState = true) {
    const wishlist = getLocalWishlist();
    const productIndex = wishlist.indexOf(this.productHandle);
    let isActive = productIndex !== -1;

    if (shouldChangeState) {
      const product = await this.getProduct();
      if (isActive) {
        wishlist.splice(productIndex, 1);
        document.dispatchEvent(
          new CustomEvent('wishlist:removed', {
            detail: { product: product },
          })
        );
      } else {
        wishlist.push(this.productHandle);
        document.dispatchEvent(
          new CustomEvent('wishlist:added', {
            detail: { product: product },
          })
        );
      }
      isActive = !isActive;
      this.saveWishlistToLocalStorage(wishlist);
      this.updateButtonAppearance(isActive);
      await this.syncRemoteWishlist();
    } else {
      this.updateButtonAppearance(isActive);
    }
  }

  saveWishlistToLocalStorage(wishlist) {
    localStorage.setItem(CONSTANTS.LOCAL_STORAGE_WISHLIST_KEY, wishlist.join(CONSTANTS.LOCAL_STORAGE_DELIMITER));
  }

  async syncRemoteWishlist() {
    if (CONSTANTS.CUSTOMER_LOGGED_IN) {
      const productGid = await getProductGidFromHandle(this.productHandle);
      if (productGid) await updateRemoteWishlist(productGid);
    }
    document.dispatchEvent(
      new CustomEvent('wishlist:updated', {
        detail: { wishlist: getLocalWishlist() },
      })
    );
  }

  updateButtonAppearance(isActive) {
    this.classList.toggle(CONSTANTS.BUTTON_ACTIVE_CLASS, isActive);
  }
}

if (!customElements.get('wishlist-button')) {
  customElements.define('wishlist-button', WishlistButton);
}
